import React from 'react';
import './Face.css';

export default function Avatar({ name, emotion, isActive, size = 'large' }) {

  // Map emotion string to CSS class
  const getEmotionClass = (emotion, name) => {
    name = name.toLowerCase();
    if (emotion === 'neutral') {
      return name === 'alex' ? 'alpha-neutral' : 'beta-neutral';
    }

    switch (emotion) {
      // Alex emotions
      case 'angry': return 'angry';
      case 'hopeful': return 'hopeful';
      case 'resistant': return 'resistant';
      case 'relieved': return 'relieved';

      // Jordan emotions
      case 'anxious': return 'anxious';
      case 'cautious': return 'cautious';
      case 'open': return 'open';
      case 'calm': return 'calm';

      // Shared emotions
      case 'sad': return 'sad';
      case 'contempt': return 'contempt';

      default:
        return name === 'alex' ? 'alpha-neutral' : 'beta-neutral';
    }
  };

  const getDisplayEmotion = (emotion) => {
    // For display text
    if (emotion === 'neutral' || emotion === 'alpha-neutral' || emotion === 'beta-neutral') {
      return 'neutral';
    }
    return emotion;
  };

  const sizeClass = size === 'small' ? 'face-small' : 'face';
  const textSize = size === 'small' ? 'text-xs' : 'text-sm';

  return (
    <div className={`flex flex-col items-center ${size === 'small' ? 'space-y-1' : 'space-y-2'}`}>
      <div className={`${isActive ? 'ring-2 ring-blue-500 animate-pulse' : ''} rounded-full p-1`}>      
        <div className={`${sizeClass} ${getEmotionClass(emotion, name)}`}>
          <div className="mouth"></div>
        </div>
      </div>
      <div className="text-center">
        <p className={`${textSize} font-medium ${name === 'Alex' ? 'text-red-700' : 'text-blue-700'}`}>
          {name}
        </p>
        <p className={`${textSize} text-gray-500 capitalize`}>
          {getDisplayEmotion(emotion)}
        </p>
      </div>
    </div>
  );
}
